// extracted by mini-css-extract-plugin
module.exports = {"card":"Termination_card__1nWo3","container":"Termination_container__WBwe4","fadeIn":"Termination_fadeIn__3mnXz","fadeOut":"Termination_fadeOut__3rirp"};